import { Outlet, useOutletContext } from 'react-router-dom'

import NotFound from 'modules/core/components/NotFound'

import AutomationHistory from 'modules/automations/components/AutomationHistory'
import type { ShowRouteContextParams } from 'modules/automations/lib/ShowRouteContextParams'
import { InsertAutomationProvider } from 'modules/automations/lib/automationContext'

const HistoryPage = () => {
  const { automation, back } = useOutletContext<ShowRouteContextParams>()

  if (!automation) {
    return <NotFound />
  }

  return (
    <InsertAutomationProvider>
      <AutomationHistory automation={automation} back={back}>
        <Outlet />
      </AutomationHistory>
    </InsertAutomationProvider>
  )
}

export default HistoryPage
